import React from 'react';
import PropTypes from 'prop-types';
import Button from 'core/ui/Button';
import {
	Wrapper,
	Title,
	Message,
} from './errorStyles';

const ErrorContainer = ({ message, onClickButton }) =>
	<Wrapper>
		<Title>Oh No! 😢</Title>
		<Message>{message}</Message>
		{message === ErrorContainer.defaultProps.message &&
			<Message>Please contact support or</Message>
		}
		<Button onClick={onClickButton}>Try Again</Button>
	</Wrapper>;


ErrorContainer.propTypes = {
	message: PropTypes.string,
	onClickButton: PropTypes.func,
};

ErrorContainer.defaultProps = {
	message: 'Something went bad on our end.',
	onClickButton: () => null,
};

export default ErrorContainer;
